(function () {
  if (window.__paidAddonsCleanup) return;
  window.__paidAddonsCleanup = true;

  const root =
    window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const originalFetch = window.fetch.bind(window);
  let busy = false;

  async function refreshUI() {
    // Cart page: simplest reliable option is a reload
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }

    // Cart drawer: refresh its HTML and the cart icon, without opening it
    const cart = document.querySelector('cart-drawer');
    if (!cart) return;

    const sections =
      typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender()
        : [
            { id: 'cart-drawer', selector: '#CartDrawer' },
            { id: 'cart-icon-bubble' }
          ];

    const ids = sections.map(s => s.id).join(',');
    const res = await originalFetch(
      root + '?sections=' + ids + '&t=' + Date.now(),
      { cache: 'no-store' }
    );
    if (!res.ok) return;
    const data = await res.json();

    sections.forEach(s => {
      const target = s.selector
        ? document.querySelector(s.selector)
        : document.getElementById(s.id);
      if (!target || !data[s.id]) return;
      const doc = new DOMParser().parseFromString(data[s.id], 'text/html');
      const source = doc.querySelector(s.selector || '.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    });

    const overlay = cart.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof cart.close === 'function') {
      overlay.addEventListener('click', cart.close.bind(cart));
    }
  }

  async function cleanup() {
    if (busy) return;
    busy = true;

    try {
      const cartRes = await originalFetch(root + 'cart.js', {
        cache: 'no-store'
      });
      const cart = await cartRes.json();

      // Groups that still have a main product line
      const activeGroups = new Set();
      cart.items.forEach(item => {
        const p = item.properties || {};
        if (p._addon_group && !p['_Add-on for']) {
          activeGroups.add(p._addon_group);
        }
      });

      // Add-on lines whose main product is gone
      const orphans = cart.items.filter(item => {
        const p = item.properties || {};
        return (
          p['_Add-on for'] &&
          p._addon_group &&
          !activeGroups.has(p._addon_group)
        );
      });

      if (!orphans.length) return;

      for (const item of orphans) {
        await originalFetch(root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      }

      await refreshUI();
    } catch (error) {
      console.error('Paid add-ons cleanup:', error);
    } finally {
      busy = false;
    }
  }

  // Run cleanup after any cart change/update request made by the theme
  window.fetch = async function (input, init) {
    const response = await originalFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(change|update)/.test(url)) {
        setTimeout(cleanup, 400);
      }
    } catch (e) {}
    return response;
  };

  // Also clean up on page load (e.g. cart changed in another tab)
  document.addEventListener('DOMContentLoaded', cleanup);
})();